<router-outlet></router-outlet>
<sh-app-version [versionData]="versionData"></sh-app-version>
